<template>
  <el-dialog
    v-drag
    title="当前客服-客户列表"
    :visible.sync="dialogVisible"
    width="800px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div class="content">
      <BaseTable
        :tableData="{
          ...tableData,
          columns
        }"
        :height="400"
        :isPager="false">
      </BaseTable>
      <div class="search">
        <el-select
          v-model="operateId"
          style="width: 100%"
          placeholder="请选择转移至客服"
          filterable
        >
          <el-option
            v-for="option in userOptions"
            :key="option.value"
            :label="option.label"
            :value="option.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取消</div>
      <div class="ok flex_c_c" @click="ok('form')">确定</div>
    </span>
  </el-dialog>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
import { getCustomerList, exchangeCustomer } from '@/api/system'
export default {
  components: {
    BaseTable
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
        operateId: '',
      tableData: {
        fileds: [
          {
            filed: 'code',
            label: '编码'
          },
          {
            filed: 'nameCH',
            label: '中文名称'
          },
          {
            filed: 'nameEN',
            label: '英文名称'
          },
          {
            filed: 'wbName',
            label: '简称'
          }
        ],
        columns: [],
        total: 0
      },
      userDate: []
    }
  },
  computed: {
    columns() {
        console.log(this.userDate.find((a) => a.id === this.userId))
      return this.userDate.find((a) => a.id === this.userId)?.companyList
    },
    userOptions() {
        return this.userDate.filter(a => a.id !== this.userId).map(a => {
            return {
                value: a.id,
                label: a.nameCH
            }
        })
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getAccountList()
      }
    }
  },
  methods: {
    async getAccountList() {
      try {
        const res = await getCustomerList()
        if (res.success) {
          this.userDate = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    cancel() {
      this.$emit('cancel')
    },
   async ok() {
      if (!this.operateId) {
        this.$message.error('未选择转移客服')
      }
      try {
        const res = await exchangeCustomer({
            targetId: this.userId,
            operateId: this.operateId
        })
        if (res.success) {
            this.$message.success('转移成功')
            this.$emit('ok')
        } else {
            this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
     }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  height: auto;
  .search {
    margin-top: 20px
  }
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
